import { store } from '../app/store';
import { AppConstants } from '../constants/AppConstants';

let roleAPIPermisions: any = {};
let userRoleName;
let ignorePermissionCheck: any;

const setApiPermissions = (state: any) => {
  roleAPIPermisions = state.initialLoadData?.apiPermissions || {};
  userRoleName = state.userManagement.userRole || '';
  ignorePermissionCheck = userRoleName === AppConstants.USER_ROLE_IT_ADMIN;
};

const listener = () => {
  setApiPermissions(store.getState());
};

store.subscribe(listener);

export const apiPermissionCheck = (apiPermissions: string[] = []) => {
  return apiPermissions.length
    ? apiPermissions.filter((apiPermission: string) => roleAPIPermisions[apiPermission]).length ===
        apiPermissions.length
    : false;
};

export const checkForPermission = (permission: string[] = []) => {
  return ignorePermissionCheck ? true : apiPermissionCheck(permission);
};
